import { router } from "@inertiajs/react";
import { SignatureForm } from "../../components/signature/SignatureForm";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import type { Coach } from "../../models/coach";
import { signatures_path } from "../../routes";

type SignatureCreateProps = {
  coaches: Coach[];
};

export default function SignatureCreate({ coaches }: SignatureCreateProps) {
  const { pathWithYearContext } = useYearContext();
  return (
    <ContentShell onBack={() => router.get(pathWithYearContext(signatures_path))} title="Neue Unterschrift">
      <SignatureForm
        coaches={coaches}
        onSubmit={(values) => router.post(pathWithYearContext(signatures_path), values)}
        saveButtonLabel="Erstellen"
      />
    </ContentShell>
  );
}
